module.exports = __webpack_public_path__ + "static/media/presto_logo.78b9d419.svg";